import React, { useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.css';
import Banner from "./secondary/Banner";
import BotonesHome from "./secondary/BotonesHome";
import ExplorarHome from "./secondary/ExplorarHome";
import Footer from "./secondary/Footer";
// import ToggleVersion from "../../ToggleVersion";

const Home = () => {
    useEffect(() => {
        const root = document.getElementById("root");
        if (root) {
            root.scrollIntoView({ behavior: "auto" });
        }
    }, []);

    return (
        <div className="home-container">
            <Banner />
            <BotonesHome />
            <ExplorarHome />
            <Footer />
            {/* <ToggleVersion /> */}
        </div>
    );
};

export default Home;
